import { createTheme } from '@mui/material/styles';

export const colorTokens = {
  background: '#f7f8fc',
  surface: '#ffffff',
  text: '#111827',
  mutedText: '#64748b',
  border: '#e2e8f0',
  primary: '#2563eb',
  primaryDark: '#1d4ed8',
  accent: '#d97706',
  accentDark: '#b45309',
  secondary: '#0f766e',
  success: '#15803d',
  scrabble: {
    normal: '#f1f5f9',
    dl: '#cde8ff',
    tl: '#8ac8ff',
    dw: '#ffd6df',
    tw: '#ff9fb8',
    quadWord: '#c4a5ff',
    quadLetter: '#a7f3ff',
    rack: '#d6af72',
    tile: '#f7ebcd',
    tileText: '#334155',
    coord: '#94a3b8',
  },
};

export const getAppTheme = () => {
  const c = colorTokens;

  return createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: c.primary,
        dark: c.primaryDark,
      },
      accent: {
        main: c.accent,
        dark: c.accentDark,
      },
      secondary: {
        main: c.secondary,
      },
      success: {
        main: c.success,
      },
      background: {
        default: c.background,
        paper: c.surface,
      },
      text: {
        primary: c.text,
        secondary: c.mutedText,
      },
      divider: c.border,
      scrabble: c.scrabble,
    },
    shape: {
      borderRadius: 12,
    },
    typography: {
      fontFamily:
        'Inter, "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
  });
};